import { render } from "./IntroPage.vue?vue&type=template&id=04273376"
import script from "./IntroPage.vue?vue&type=script&lang=js"
export * from "./IntroPage.vue?vue&type=script&lang=js"

import "./IntroPage.vue?vue&type=style&index=0&id=04273376&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__